<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Дополнительные контакты</h1>

                <div class="form-wrap__row">
                    <p class="form-wrap__info-title">Укажите данные контактных лиц, которые могут подтвердить вашу личность</p>
                </div>
                <div class="form-wrap__row">
                    <c-radio-group v-model="firstRelativeAccountedFor" :valueList="firstContactList" :label="'Родственник'"
                                   :fieldName="'firstRelativeAccountedFor'"
                                   v-on:change=""></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="firstRelativeAccountedFor !== ''">
                    <c-input
                            :label="firstContactPhone"
                            :type="'tel'"
                            :fieldName="'firstRelativePhone'"
                            :validation="'decimal'"
                            :mask="'+7(###)###-##-##'"

                            :externalStatus="firstRelativePhoneExternalStatus"
                            v-model="firstRelativePhone"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="firstRelativeAccountedFor !== ''">
                    <c-input
                            :label="firstContactFIO"
                            :type="'text'"
                            :fieldName="'firstRelativeFIO'"

                            :externalStatus="firstRelativeFIOExternalStatus"
                            v-model="firstRelativeFIO"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>


                <div class="form-wrap__row" v-if="firstRelativeFIO !== ''">
                    <c-radio-group v-model="secondRelativeAccountedFor" :valueList="secondContactList" :label="'Второе контактное лицо'"
                                   :fieldName="'secondRelativeAccountedFor'"
                                   v-on:change=""></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="secondRelativeAccountedFor !== ''">
                    <c-input
                            :label="secondContactPhone"
                            :type="'tel'"
                            :fieldName="'secondRelativePhone'"
                            :validation="'decimal'"
                            :mask="'+7(###)###-##-##'"

                            :externalStatus="secondRelativePhoneExternalStatus"
                            v-model="secondRelativePhone"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="secondRelativeAccountedFor !== ''">
                    <c-input
                            :label="secondContactFIO"
                            :type="'text'"
                            :fieldName="'secondRelativeFIO'"

                            :externalStatus="secondRelativeFIOExternalStatus"
                            v-model="secondRelativeFIO"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                
                <div class="form-wrap__row" v-if="secondRelativeFIO !== ''">
                    <p class="form-wrap__text-info"></p>
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'Refining'}"
                                     @click.native="save(['firstRelativeType','firstRelativeInfo','secondRelativeType','secondRelativeInfo'])"
                                     tag="button" class="form-button form-button--yellow form-button--long-text">
                            Продолжить
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {createHelpers} from 'vuex-map-fields';
    import store from '@/storage/index'
    import {GET_PROFILE} from "@/storage/mutations";
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import {STATUSES} from "@/components/statuses";
    import registrationMixins from '@/modules/mixins/registrationMixins'

    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });

    const declensionList = {
        WIFE: 'жены',
        HUSBAND: 'мужа',
        SON: 'сына',
        DAUGHTER: 'дочери',
        MOTHER: 'мамы',
        FATHER: 'папы',
        SISTER: 'сестры',
        BROTHER: 'брата',
        UNCLE: 'дяди',
        AUNT: 'тёти',
        GRANDMOTHER: 'бабушки',
        GRANDFATHER: 'дедушки',
        FRIEND: 'друга',
        COLLEAGUE: 'коллеги',
        OTHER: '',
    };


    export default {
        mixins: [registrationMixins],
        name: 'Employment',
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {

            }
        },
        watch: {},
        methods: {
            selectWorkType: function(){
                BLOCKS_CONFIG[0].confirmed = UNEMPLOYMENT_TYPES.indexOf(this.workType) > -1;
            },

        },
        asyncComputed: {},
        computed: {
            firstContactList:function () {
                let sex = this.$store.state.profile.sex;
                return [
                    {
                        label: sex === 'MALE' ? 'Жена' : 'Муж',
                        value: sex === 'MALE' ? 'WIFE' : 'HUSBAND'
                    },
                    {
                        label: 'Сын',
                        value: 'SON'
                    },
                    {
                        label: 'Дочь',
                        value: 'DAUGHTER'
                    },
                    {
                        label: 'Мама',
                        value: 'MOTHER'
                    },
                    {
                        label: 'Папа',
                        value: 'FATHER'
                    },
                    {
                        label: 'Сестра',
                        value: 'SISTER'
                    },
                    {
                        label: 'Брат',
                        value: 'BROTHER'
                    },
                    {
                        label: 'Бабушка',
                        value: 'GRANDMOTHER'
                    },
                    {
                        label: 'Дедушка',
                        value: 'GRANDFATHER'
                    },
                    {
                        label: 'Дядя',
                        value: 'UNCLE'
                    },
                    {
                        label: 'Тетя',
                        value: 'AUNT'
                    },
                    {
                        label: 'Другое',
                        value: 'OTHER'
                    }
                ]
            },
            secondContactList:function () {
                return [
                    {
                        label: 'Коллега',
                        value: 'COLLEAGUE'
                    },
                    {
                        label: 'Друг',
                        value: 'FRIEND'
                    }
                ]
            },
            firstContactPhone: function () {
                return 'Телефон '+declensionList[this.firstRelativeAccountedFor];
            },
            firstContactFIO: function () {
                return 'ФИО '+declensionList[this.firstRelativeAccountedFor];
            },
            secondContactPhone: function () {
                return 'Телефон '+declensionList[this.secondRelativeAccountedFor];
            },
            secondContactFIO: function () {
                return 'ФИО '+declensionList[this.secondRelativeAccountedFor];
            },





            ...mapFields([
                'firstRelativePhone',
                'firstRelativePhoneExternalStatus',

                'firstRelativeFIO',
                'firstRelativeFIOExternalStatus',

                'firstRelativeAccountedFor',
                'firstRelativeAccountedForExternalStatus',

                'secondRelativePhone',
                'secondRelativePhoneExternalStatus',

                'secondRelativeFIO',
                'secondRelativeFIOExternalStatus',

                'secondRelativeAccountedFor',
                'secondRelativeAccountedForExternalStatus',
            ]),
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 60, nextPercent: 10});
        }
    }
</script>

<style lang="scss">

</style>